import { Translation } from 'app/entities/Translation';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {environment, productModels} from '../../../environments/environment';
import {AppConfig} from '../../app.config';
import {TaskService} from '../../services/task.service';
import {Task, TaskLevel} from 'app/entities/Task';
import {TaskActivity} from '../../entities/TaskActivity';
import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {FilterModel} from '../../entities/FilterModel';
import * as moment from 'moment';
import {AppTaskCategory} from '../../entities/AppTaskCategory';
import {MaintenanceObject_DTO} from '../../entities/MaintenanceObject_DTO';
import {Responsible} from '../../entities/SalesPerson';
import { SessionService } from 'app/services/session.service';
import { TranslationService } from 'app/services/translation.service';
import { ConverterService } from 'app/services/converter.service';

declare var $: any;

@Component({
  selector: 'app-notification-overview-view',
  templateUrl: './notification-overview-view.component.html',
  styleUrls: ['./notification-overview-view.component.css']
})
export class NotificationOverviewViewComponent implements OnInit {

  public notifications: any[] = []
  public chosenNotification: any = {};
  public orderParameter: string = 'No';
  public sortReverse: boolean = false;
  public loading: boolean;
  public searchInput: string = '';
  public productModels = productModels;
  public currentProductModel: any;
  public maintenanceObjectNo?: string;
  public createdBy?: string;
  public taskCreated?: boolean;
  public categoryNo?: number;
  public appTaskCategories: AppTaskCategory[];
  public maintenanceObjectDTO: MaintenanceObject_DTO;
  public salespersons: Responsible[];
  translations: Map<string, Translation>;
  companies: any[];
  heightStyle = {height: $(window).height() - 130 + 'px'};

  /** Date navigation **/
  public StartDate;
  public EndDate;
  public dummyStart;
  public dummyEnd;

  public startDatePickerOptions: IMyDpOptions;
  public endDatePickerOptions: IMyDpOptions;
  currentLanguage: string;

  public chosenTask: Task = new Task();

  @Output()
  updateNotificationEmitter = new EventEmitter();
  @Output()
  createNotificationEmitter = new EventEmitter();
  @Output()
  updateTaskEmitter = new EventEmitter();
  @Output()
  updateActivitiesEmitter = new EventEmitter();
  @Output()
  refreshDataEmitter = new EventEmitter();




  @Input()
  set Companies(value: any[]){
    this.companies = value;
  }

  @Input('notifications')
  set Notifications(result: any[]) {
    this.notifications = result;

    if (this.chosenNotification != null) {
      this.chosenNotification = Object.assign({}, this.notifications.find(x => x.Notification_GUID == this.chosenNotification.Notification_GUID));
    }
    this.loading = false;
  }

  @Input('navigationDate')
  set NavigationDate(result: Date) {
    this.initDateNavigation(result);
  }

  @Input('appTaskCategories')
  set AppTaskCategories(result: AppTaskCategory[]) {
    this.appTaskCategories = result;
  }

  @Input('maintenanceObjectDTO')
  set MaintenanceObjectDTO(result: MaintenanceObject_DTO) {
    this.maintenanceObjectDTO = result;
  }

  @Input('salespersons')
  set Salespersons(result: Responsible[]) {
    this.salespersons = result;
  }

  @Input()
  loggedInUserNo: string;

  constructor(private appConfig: AppConfig,
              private taskService: TaskService,
              private sessionService: SessionService,
              private translationService: TranslationService,
              public convertService: ConverterService,              
              ) {
  }

  ngOnInit() {
    this.currentProductModel = this.appConfig.getConfig('productModel');
    window.addEventListener('resize', () => {
      this.heightStyle =  {height: $(window).height() - 130 + 'px'}
    });

    const activeLanguageSub = this.translationService.getLanguageSubject().subscribe(language => {
      this.currentLanguage = language;
     }, () => {}, () => {activeLanguageSub.unsubscribe()})
  }

  get isSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS;
  }
  
  setOrderParameter(para: string) {
    if (this.orderParameter == para) {
      this.sortReverse = !this.sortReverse;
    }
    this.orderParameter = para;
  }

  openCreateModal() {
    setTimeout(() => {
      $('#createNotificationModal').modal('show');
    }, 50);
  }

  createNotificationAndClose(notification) {
    this.loading = true;
    this.createNotificationEmitter.emit(notification);
    $('#createNotificationModal').modal('hide');
  }

  openUpdateModal() {
    setTimeout(() => {
      $('#updateNotificationModal').modal('show');
    }, 50);
  }


  updateNotification(notification) {
    this.loading = true;
    this.updateNotificationEmitter.emit(notification);
  }

  updateNotificationAndClose(notification) {
    this.loading = true;
    this.updateNotificationEmitter.emit(notification);

    $('#updateNotificationModal').modal('hide');
  }

  chooseNotification(notification: any) {
    this.chosenNotification = Object.assign({}, notification);
    this.openUpdateModal();
  }

  trackByNotification(index: number, notification: any) {
    return notification && (notification.Notification_GUID || notification.No || index);
  }

  getNotificationTitle(notification: any): string {
    if (!notification) {
      return '';
    }

    return notification.Description || notification.Extended_Description || notification.Maintenance_Object_Description || '';
  }

  getNotificationSubtitle(notification: any): string {
    if (!notification) {
      return '';
    }

    return notification.Extended_Description || '';
  }

  getNotificationAccentColor(notification: any): string {
    return notification && notification.Critical ? '#d9534f' : '#4f93cb';
  }


  showAppTaskModal(taskGuid: any) {
    this.taskService.getTask(taskGuid).subscribe(x => {
      this.chosenTask = Object.assign({}, x);
      setTimeout(() => {
        $('#myModal').modal('show');
      }, 250);
    });
  }

  setOptionsData() {
    this.dummyStart = {date: {year: this.StartDate.getFullYear(), month: this.StartDate.getMonth() + 1, day: this.StartDate.getDate()}};
    this.dummyEnd = {date: {year: this.EndDate.getFullYear(), month: this.EndDate.getMonth() + 1, day: this.EndDate.getDate()}};


    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: this.dummyEnd.date, end: {year: 2055, month: 11, day: 20}}],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{begin: {year: 1980, month: 11, day: 20}, end: this.dummyStart.date}],
    };
  }

  setStartDate(event: IMyDateModel) {
    $('.btn-with-tooltip').blur();
    this.StartDate = event.jsdate;
    this.setOptionsData();

    // Maintenance
    this.refreshData();
  }

  goForwardNumberOfDays(numberOfDays: number) {

    this.StartDate.setDate(this.StartDate.getDate() + numberOfDays)
    this.EndDate.setDate(this.EndDate.getDate() + numberOfDays)
    this.setOptionsData();

    // Maintenance
    this.refreshData();
  }

  setEndDate(event: IMyDateModel) {
    $('.btn-with-tooltip').blur();

    this.EndDate = event.jsdate;

    this.setOptionsData();

    // Maintenance
    this.refreshData();

  }

  refreshData() {
    this.refreshDataEmitter.emit(new FilterModel(moment(this.StartDate).format(environment.FULL_DATETIME_FORMAT), moment(this.EndDate).format(environment.FULL_DATETIME_FORMAT), this.maintenanceObjectNo, this.createdBy, this.taskCreated, this.categoryNo));
  }

  updateTask(task: Task) {
    this.updateTaskEmitter.emit(task);
  }

  updateTaskActivities(activities: TaskActivity[]) {
    this.updateActivitiesEmitter.emit(activities);
  }

  private initDateNavigation(defaultDate: Date) {
    let d = new Date(defaultDate);

    let startDate = new Date(d.setDate(d.getDate() - 1));

    this.StartDate = new Date(startDate);
    this.StartDate.setHours(0);
    this.StartDate.setMinutes(0);
    this.StartDate.setSeconds(0);

    let diff2 = startDate.getDate() + 6;
    this.EndDate = new Date(startDate.setDate(diff2));
    this.EndDate.setHours(0);
    this.EndDate.setMinutes(0);
    this.EndDate.setSeconds(0);

    this.setOptionsData();

    // Maintenance
    this.refreshData();
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/notification-overview/notification-overview-view.component.ts